/*
 * Return results like "100 km / j"consumption.options or "Kilomètres illimités"
 */
export function useFormatKilometerPerDay() {
  const { $i18n: { t, n } } = useNuxtApp()
  return ({ count }: { count: number }): string => {
    return count ? n(count, { style: 'unit', unit: 'kilometer-per-day', unitDisplay: 'short' }) : t('commons.options.km.km_unlimited')
  }
}
